import { render, staticRenderFns } from "./FullBlockVideo.vue?vue&type=template&id=71acce35&scoped=true"
import script from "./FullBlockVideo.vue?vue&type=script&lang=js"
export * from "./FullBlockVideo.vue?vue&type=script&lang=js"
import style0 from "./FullBlockVideo.vue?vue&type=style&index=0&id=71acce35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acce35",
  null
  
)

export default component.exports